import { CloseSearchSVG } from "../../assets/svg/CloseSearch";
import { SearchIcon } from "../../assets/svg/SearchIcon";
import s from "./Search.module.scss";
import { FC, useId } from "react";

type SearchT = {
  setValue: any;
  value: string;
};
export const Search: FC<SearchT> = ({ ...props }) => {
  const { value, setValue } = props;
  const searchId = useId();

  function changeValue(value: any) {
    setValue(value);
  }
  return (
    <div className={s.wrapper}>
      <label htmlFor={searchId}>
        <SearchIcon />
      </label>
      <input
        type="text"
        name="search"
        value={value}
        onChange={(e) => changeValue(e.target.value)}
        id={searchId}
        placeholder="Search"
      />
      {value.length > 0 && (
        <span className={s.close} onClick={() => changeValue("")}>
          <CloseSearchSVG />
        </span>
      )}
    </div>
  );
};
